import { render, staticRenderFns } from "./List1.vue?vue&type=template&id=a0427ea2&scoped=true"
import script from "./List1.vue?vue&type=script&lang=js"
export * from "./List1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0427ea2",
  null
  
)

export default component.exports